import { DashboardColumn } from '../types'

export const defaultDashboard = {
  Id: 0,
  Name: '',
}

export const ACTUAL_CONTENTS_DEFAULT_DASHBOARD_ID = 0
export const DELETED_CONTENTS_DEFAULT_DASHBOARD_ID = -1

export const reindexColumns = (cols: DashboardColumn[]): DashboardColumn[] => {
  return cols
    .slice()
    .sort((a, b) => a.Order - b.Order)
    .map((col, index) => ({
      ...col,
      Order: index + 1,
    }))
}
